import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import './overview.scss';

export default ({ field_overview, ...rest }) => {
  const Summary = (
    <Col xs={12}>
      <h3>Overview</h3>
      <div
        dangerouslySetInnerHTML={{
          __html: field_overview.field_html.processed,
        }}
      />
    </Col>
  );
  return (
    <section {...rest}>
      <Container>
        <Row>{Summary}</Row>
      </Container>
    </section>
  );
};
